module.exports = __webpack_public_path__ + "static/img_refuse@2x-31b5689d54dc959eba0035a28f95240a.png";